import { Chart as ChartJS, registerables } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(...registerables);

interface GenderDistributionData {
  name: string;
  value: number;
  color: string;
  count: number;
}

interface GenderCardProps {
  selectedTopic: string;
  genderDistributionData?: GenderDistributionData[];
  maleUsers?: number;
  femaleUsers?: number;
}

const GenderCard = ({ 
  selectedTopic, 
  genderDistributionData = [],
  maleUsers = 0,
  femaleUsers = 0
}: GenderCardProps) => {
  // Dinamik ma'lumotlardan foydalanish
  const male = maleUsers;
  const female = femaleUsers;
  const total = male + female;

  // Calculate percentages
  const malePercentage = total > 0 ? ((male / total) * 100).toFixed(1) : '0';
  const femalePercentage = total > 0 ? ((female / total) * 100).toFixed(1) : '0';

  const data = {
    labels: ['Erkak', 'Ayol'],
    datasets: [
      {
        data: [male, female],
        backgroundColor: ['#3b82f6', '#ec4899'],
        borderWidth: 0,
        cutout: '60%'
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 500,
      easing: 'easeOutQuart' as const
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        backgroundColor: '#1e293b',
        padding: 12,
        borderRadius: 8,
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: function (context: any) {
            const label = context.label || '';
            const value = context.parsed || 0;
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : '0';
            return `${label}: ${value.toLocaleString()} (${percentage}%)`;
          }
        }
      }
    }
  };

  const legendData = [
    {
      color: 'blue',
      label: 'Erkak',
      value: male.toLocaleString()
    },
    {
      color: 'pink',
      label: 'Ayol',
      value: female.toLocaleString()
    }
  ];

  return (
    <div className="participation-card gender-card">
      <div className="participation-header">
        <h3>Jinsi kesimida</h3>
      </div>
      <div className="circular-stats-large">
        <div className="chart-wrapper">
          <div className="center-percentage">
            <div className="percentage-value">{total.toLocaleString()}</div>
            <div className="percentage-label">Jami</div>
          </div>
          <Doughnut data={data} options={options} />
        </div>
        <div className="circular-legend">
          {legendData.map((item, index) => (
            <div key={index} className="legend-item">
              <span className={`legend-dot ${item.color}`}></span>
              <span className="legend-label">{item.label}</span>
              <span className="legend-value">{item.value}</span>
            </div>
          ))}
        </div>
        <div className="participation-summary">
          <div className="summary-item">
            <div className="summary-label">Erkak</div>
            <div className="summary-value">{malePercentage}%</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-item">
            <div className="summary-label">Ayol</div>
            <div className="summary-value">{femalePercentage}%</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderCard;
